import React from 'react';
import Header from '../../Layout/Header';
import Footer from '../../Layout/Footer';
import FAQ from './FAQ';
import SeoTagsFooter from './SeoTagsFooter';

function DigitalMarketingSolutions() {
  const faqs = [
    {
      question: "What Digital Marketing services does Mokshiq provide?",
      answer: "Mokshiq (Rakle Service Private Limited) offers Search Engine Optimization (SEO), Social Media Optimization (SMO), Google Pay-Per-Click (PPC) campaigns, Content Marketing, and Lead Generation for Fintech and B2B enterprises."
    },
    {
      question: "How long before we see SEO results?",
      answer: "Organic SEO campaigns typically yield measurable rankings, organic traffic growth, and lead increases within 60 to 90 days."
    }
  ];

  return (
    <div className="page_wrapper">
      <Header />
      <main className="page_content">
        <section className="page_header text-center bg-dark section_decoration overflow-hidden py-5" style={{ backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')" }}>
          <div className="container">
            <span className="badge bg-warning text-dark px-3 py-2 text-uppercase mb-3 font-weight-bold" style={{ letterSpacing: '1px' }}>
              <i className="fa-solid fa-chart-line me-2"></i>Marketing &amp; Growth
            </span>
            <h1 className="page_title text-white mb-3">Digital Marketing &amp; SEO Solutions</h1>
            <p className="text-white-50 mx-auto" style={{ maxWidth: '750px' }}>
              Data-driven SEO, Google PPC, Social Media Optimization, and Lead Growth powered by <strong>Rakle Service Private Limited</strong>.
            </p>
            <ul className="breadcrumb_nav unordered_list justify-content-center mt-3">
              <li><a href="/">Home</a></li>
              <li><a href="/services">Services</a></li>
              <li className="active"><a href="#!">Digital Marketing</a></li>
            </ul>
          </div>
        </section>

        <section className="section_space bg-white">
          <div className="container">
            <div className="row g-4">
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-magnifying-glass-chart text-primary fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Search Engine Optimization (SEO)</h3>
                  <p className="text-muted small">On-page technical SEO, off-page link building, and keyword ranking for fintech services.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-brands fa-google text-danger fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Google PPC &amp; Search Ads</h3>
                  <p className="text-muted small">Targeted search ads, remarketing campaigns, and high-converting landing page optimization.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-share-nodes text-success fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Social Media Optimization (SMO)</h3>
                  <p className="text-muted small">Brand management on LinkedIn, Facebook, Instagram, and Twitter/X for corporate authority.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FAQ faqList={faqs} title="Digital Marketing FAQs" subtitle="Frequently asked questions about SEO and PPC marketing services." />
      </main>
      <Footer />
      <SeoTagsFooter />
    </div>
  );
}

export default DigitalMarketingSolutions;
